import { render } from "./PublicGamificationLeaderboard.vue?vue&type=template&id=4fe7b268&ts=true"
import script from "./PublicGamificationLeaderboard.vue?vue&type=script&lang=ts"
export * from "./PublicGamificationLeaderboard.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__